import { t } from "i18next";
import { ReactElement } from "react";

import { ICatalogue } from "../../../apis/useGetCatalogueData/types";
import { centsToDollarsDisplay } from "../../../common/helpers/stringUtils";
import Condition from "../../../components/Conditional/Condition";
import I18nText from "../../../components/I18nText/I18nText";
import { useCartContext } from "../../../contexts/CartServiceContext/CartServiceContext";
import PaymentDetailCustomizations from "./PaymentDetailCustomizations";
import PaymentDetailSetItems from "./PaymentDetailSetItems";

interface IProps {
	item: ICatalogue;
}

const PaymentDetailItem = ({ item }: IProps): ReactElement => {
	const {
		state: { is_takeaway },
	} = useCartContext((state) => state);

	const hasCustomizations = item.food_supplier_customizations?.length > 0;
	const hasSetItems = item.food_supplier_set_items?.length > 0;

	return (
		<li className="CartItem">
			<div className="ItemHeader">
				<div className="ItemName">
					<I18nText
						className="ItemNameText"
						enText={item.title ?? item.title_en}
						cnText={item.title_cn}
					/>
				</div>
				<div className="ItemHeaderRight">
					<span className="ItemQuantity">{item.quantity}</span>
					<span className="Price TabularNums">{`$${centsToDollarsDisplay(item.gross_value)}`}</span>
				</div>
			</div>

			<Condition check={item.final_price}>
				<div className="ItemFinalPrice">{t("item.finalPrice")}</div>
			</Condition>

			<div className="ItemContents">
				<Condition check={hasCustomizations}>
					<PaymentDetailCustomizations customizations={item.food_supplier_customizations} />
				</Condition>

				<Condition check={hasSetItems}>
					<PaymentDetailSetItems setItems={item.food_supplier_set_items} />
				</Condition>

				<Condition check={is_takeaway && item.takeaway_fee > 0}>
					<div className="CartItemTakeawayFee">
						<div className="TakeawayFee">
							<div className="TakeawayFeeTitle">{t("cartPage.item.takeawayfee")}</div>
							<span className="TakeawayFeeValue TabularNums">
								+ ${centsToDollarsDisplay(item.takeaway_fee)}
							</span>
						</div>
					</div>
				</Condition>
			</div>
		</li>
	);
};

export default PaymentDetailItem;
